import React, { forwardRef, memo, useImperativeHandle, useState } from 'react';

import { useDisclosure } from '@chakra-ui/hooks';

import { useSKU } from 'hooks/useSKU';

import { washHub } from 'store/slices';

import { updateCase } from 'api/items';
import { useMutation, useQueryClient } from 'react-query';

import { successToast } from 'utils/successToast';

import { Case } from 'types/items';
import { RefType, EditCaseModalProps } from './EditCaseModal.props';

import EditCaseModalView from './EditCaseModal.view';

const Container = forwardRef<RefType, EditCaseModalProps>((_, ref) => {
  const queryClient = useQueryClient();

  const washHubId = washHub.selectors.useSelectedWashHubId();

  const { isOpen, onOpen, onClose } = useDisclosure();

  const [_case, setCase] = useState<Case | null>(null);

  const { data: skus = [], isLoading: isLoadingSKU } = useSKU('case');

  const { mutate, isLoading } = useMutation(updateCase, {
    onSuccess: () => {
      successToast('Case updated successfully');

      queryClient.invalidateQueries(`fetch-cases-${washHubId}`);

      onClose();
    },
  });

  useImperativeHandle(
    ref,
    () => ({
      onOpen: (__case) => {
        setCase(__case);

        onOpen();
      },
    }),
    [],
  );

  const onSubmit = (values: any) => {
    values = {
      _id: _case?._id,
      washHub: washHubId,
      sku: values?.sku,
      rfid: values?.rfid,
      status: Number(values?.status || '0'),
      packageId: values?.packageId || '',
    };

    mutate(values);
  };

  const _props = {
    skus,
    _case,
    isOpen,
    onClose,
    onSubmit,
    isLoading,
    isLoadingSKU,
  };

  return <EditCaseModalView {..._props} />;
});

const EditCaseModal = memo(Container);

export default EditCaseModal;
